import { render, staticRenderFns } from "./BurgerFooter.vue?vue&type=template&id=55ac9511&"
import script from "./BurgerFooter.vue?vue&type=script&lang=js&"
export * from "./BurgerFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55ac9511')) {
      api.createRecord('55ac9511', component.options)
    } else {
      api.reload('55ac9511', component.options)
    }
    module.hot.accept("./BurgerFooter.vue?vue&type=template&id=55ac9511&", function () {
      api.rerender('55ac9511', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/BurgerFooter.vue"
export default component.exports